import { Link } from "react-router-dom";
import { navSites } from "@/mocks/navSites";
import SiteCard from "@/components/feature/SiteCard";
import useFavorites from "@/hooks/useFavorites";

export default function FeaturedSection() {
  const featured = navSites.filter((site) => site.featured).slice(0, 6);
  const { isFavorite, toggle } = useFavorites();

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1 h-4 rounded-full bg-accent-500" />
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
              今日推荐
            </h2>
            <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-700 text-[11px]">
              编辑精选
            </span>
          </div>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500 ml-3">
            编辑每天从分类中挑选的高频实用网站，先看这几个准没错。
          </p>
        </div>
        <Link
          to="/search?q=%E7%B2%BE%E9%80%89"
          className="text-xs md:text-sm text-primary-600 hover:text-primary-700 flex items-center gap-0.5 cursor-pointer whitespace-nowrap"
        >
          查看更多推荐
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {featured.map((site) => (
          <SiteCard
            key={site.id}
            site={site}
            isFavorite={isFavorite(site.id)}
            onToggleFavorite={toggle}
          />
        ))}
      </div>
    </div>
  );
}